import { createSlice } from "@reduxjs/toolkit";

import i18n from "../../../locales/i18n";
import { RootState } from "../../../services/store";

const defaultLang = i18n.language;

const initialState = {
    defaultLang,
    langs: [],
};

const langSlice = createSlice({
    name: "lang",
    initialState,
    reducers: {
        setLang: (state, action) => {
            i18n.changeLanguage(action.payload);
            state.defaultLang = action.payload;
        },
        setLangs: (state, action) => {
            state.langs = action.payload;
        },
    },
});

export const { setLang, setLangs } = langSlice.actions;
export default langSlice.reducer;

export const selectLang = (state: RootState) => state.lang.defaultLang;
export const selectLangs = (state: RootState): string[] => state.lang.langs;
